import React from "react";
import { Grid, FormControlLabel, Box, useTheme, useMediaQuery } from "@material-ui/core";

import { green, red } from "@material-ui/core/colors";
import { ActiveCreditSwitch, SuspendendedCreditSwitch } from "./customSwitches";
import { CreditCard } from "@material-ui/icons";

export const CreditCustomerInputs = ({ values }) => {
  const { creditFilter, customersCredit, handleSwitches } = values;
  const {breakpoints} = useTheme();
  const query = useMediaQuery(breakpoints.down("sm"));
  const style = {
    borderRadius: 6,
    padding: 4,
    display: "flex",
    justifyContent: "space-between",
    gap: 4,
    flexGrow: query ? 1 : 0,
    flexBasis: query ? "100%" : "auto",
    alignItems: "center",
    width: query ? "100%" : "auto"
  };
  return (
    <Box
      style={{
        display: "flex",
        justifyContent: "flex-end",
        flexWrap: "wrap",
        gap: 8
      }}
    >
      <Box
        style={{
          ...style,
          background: creditFilter.active ? green[100] : green[50],
          color: green[500]
          // marginRight: 2
        }}
      >
        <FormControlLabel
          label={`Credito Activo ${customersCredit.active}`}
          labelPlacement="start"
          control={
            <ActiveCreditSwitch
              checked={creditFilter.active}
              onClick={() => handleSwitches("active")}
            />
          }
          style={{ color: green[500] }}
        />
        <CreditCard
          style={{
            color: green[500],
            margin: 0,
            fontSize: 36
          }}
        />
      </Box>

      <Box
        style={{
          ...style,
          background: `${creditFilter.suspended ? red[100] : red[50]}`,
          color: red[500],
        }}
      >
        <FormControlLabel
          label={`Credito Suspendido ${customersCredit.active}`}
          labelPlacement="start"
          control={
            <SuspendendedCreditSwitch
              checked={creditFilter.suspended}
              onClick={() => handleSwitches("suspended")}
            />
          }
          style={{ color: red[500] }}
        />

        <CreditCard
          style={{
            color: red[500],
            margin: 0,
            fontSize: 36
          }}
        />
      </Box>
    </Box>
  );
};
